<template>
    <section class="section section-shaped section-lg my-0">
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-10">
                    <card shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0">
                        <div class="text-center text-muted mb-4">
                            <h5>Informasi Pembayaran Transaksi BPHTB Anda.</h5>
                            <hr>
                        </div>
                        <div v-if="loading">
                            <i class="fa fa-spinner fa-spin"></i> Loading VA Number, silahkan tunggu...
                        </div>
                        <div class="row justify-content-center" v-else>
                            <div class="col-lg-5">
                                <template v-if="isPay">
                                    <div class="text-center text-muted mb-4">
                                        <img class="img-button" width="300" src="/img/icons/3419259.jpg" />
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="text-center text-muted mb-4">
                                        <img class="img-button" width="300" src="/img/icons/6134225.jpg" />
                                    </div>
                                    <div class="text-center text-muted mb-4 text-bold">
                                        <vue-countdown :time="second">
                                            <template slot-scope="props">Waktu Pembayaran Tersisa：<br>
                                                <b>{{ props.hours }} Jam, {{ props.minutes }} menit, {{ props.seconds }}
                                                    detik.</b>
                                            </template>
                                        </vue-countdown>
                                    </div>
                                </template>
                            </div>
                            <div class="col-lg-7">
                                <div class="row">
                                    <div class="w-100"></div>
                                    <div class="col-md-3">
                                        VA
                                    </div>
                                    <div class="col-sm font-weight-bold">
                                        {{ vaNumber }}
                                    </div>
                                    <div class="w-100"></div>
                                    <div class="col-sm-3">
                                        NOP
                                    </div>
                                    <div class="col-sm font-weight-bold">
                                        {{ nop }}
                                    </div>
                                    <div class="w-100"></div>
                                    <div class="col-sm-3">
                                        Wajib Pajak
                                    </div>
                                    <div class="col-sm font-weight-bold">
                                        {{ wp }}
                                    </div>
                                    <div class="w-100"></div>
                                    <div class="col-sm-3">
                                        Total
                                    </div>
                                    <div class="col-sm font-weight-bold">
                                        {{ formatMoney(amount) }}
                                    </div>
                                    <hr>
                                </div>
                                <div class="row" v-if="!isPay">
                                    <div class="col-sm">
                                        Silahkan salin nomor va untuk membayar Transaksi Pajak BPHTB Anda.
                                        <br>
                                        <br>
                                        <span class="text-danger text-sm">Perhatian!</span>
                                        <ul>
                                            <li><span class="text-danger text-sm">Harap membayar sebelum waktu pembayaran
                                                    habis.</span></li>
                                            <li><span class="text-danger text-sm">Simpan bukti bayar Anda.</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="col-sm text-center mb-4 font-weight-bold">
                                        <br>
                                        <br>
                                        Pembayaran Anda berhasil.

                                        <br>
                                        Terimakasih sudah membayar Pajak.
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row float-right">
                                    <div class="col-md-12 col-sm-12">
                                        <base-button tag="a" class="mb-3 mb-sm-0" type="info" textColor="black"
                                            icon="fa fa-arrow-left" @click="goback()">Kembali</base-button>
                                        <base-button v-if="!isPay" type="primary" @click="checkIsAlreadyPay()">Sudah Bayar?
                                            Klik disini
                                        </base-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueCountdown from '@chenfengyuan/vue-countdown';
import axios from 'axios'
import { formatMoney } from "accounting-js";
export default {
    components: {
        VueQrcode, VueCountdown
    },
    props: ['id'],
    data() {
        return {
            isPay: false,
            loading: true,
            status: null,
            message: null,
            qrcode: null,
            code_paymets: null,
            amount: null,
            expired_time: null,
            nop: null,
            wp: null,
            second: 0,
            interval: null
        }
    },
    mounted() {
        this.getPaymentData();
        this.interval = window.setInterval(() => {
            this.checkIsAlreadyPay()
        }, 3000)
    },
    methods: {
        goback() {
            this.$router.push("/bphtb/daftar");
        },
        formatMoney(val) {
            return formatMoney(val, {
                symbol: "Rp. ",
                precision: 2,
                thousand: ".",
                decimal: ",",
            });
        },
        async getPaymentData() {
            this.loading = true
            let { data } = await axios.get(
                "/api/bphtb/payment/va/" + this.$route.params.id
            );
            if (data.status == 'success') {
                let start = new Date();
                let end = new Date(data.expired_time.replace('Z', ''));
                let diff = end - start;
                this.second = diff;
                this.amount = data.amount
                this.code_paymets = data.noBayar
                this.expired_time = data.expired_time
                this.nop = data.nop
                this.vaNumber = data.vaNumber
                this.wp = data.wp
                this.loading = false
            }
        },
        async checkIsAlreadyPay() {
            if (this.isPay) return
            let { data } = await axios.get(
                "/api/bphtb/payment/va/check/" + this.$route.params.id
            );
            if (data.status == 'success') {
                this.isPay = true
                clearInterval(this.interval)
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
    }
};
</script>
<style></style>
